module.exports = __webpack_public_path__ + "img/da.eb2ee378.png";